
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsPosScreenTypeGrid extends Serenity.EntityGrid<PsPosScreenTypeRow, any> {
        protected getColumnsKey() { return PsPosScreenTypeColumns.columnsKey; }
        protected getDialogType() { return PsPosScreenTypeDialog; }
        protected getIdProperty() { return PsPosScreenTypeRow.idProperty; }
        protected getInsertPermission() { return PsPosScreenTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosScreenTypeRow.localTextPrefix; }
        protected getService() { return PsPosScreenTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}